import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 15000,
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        console.error("API error:", err?.response?.data || err.message);
        return Promise.reject(err);
    }
);

export default api;